const messages = {
    'common.actions.close': 'Close',
    'common.actions.copy': 'Copy',
    'common.actions.share': 'Share',
    'common.actions.cancel': 'Cancel',
    'common.actions.search': 'Search',
    'common.loading': 'Loading…',
    'common.language.title': 'Language',
    'common.language.search': 'Search languages',
    'common.language.current': 'Current language',
    'common.language.group.europe': 'Europe',
    'common.language.group.asia': 'Asia',
    'common.language.group.middleEast': 'Middle East',
    'common.language.group.americas': 'Americas',
    'dice.actions.roll': 'ROLL',
    'dice.actions.replay': 'Replay',
    'dice.actions.copyLink': 'Copy link',
    'dice.actions.share': 'Share',
    'dice.actions.max': 'Max',
    'dice.actions.increaseBet': 'Increase bet',
    'dice.actions.decreaseBet': 'Decrease bet',
    'dice.actions.exitReplay': 'Exit',
    'dice.stats.balance': 'BALANCE',
    'dice.stats.bet': 'BET',
    'dice.stats.lastWin': 'LAST WIN',
    'dice.toolbar.history': 'History',
    'dice.toolbar.rules': 'Rules',
    'dice.toolbar.soundOn': 'Sound on',
    'dice.toolbar.soundOff': 'Sound off',
    'dice.toolbar.language': 'Language',
    'dice.sound.enabled': 'Sound on',
    'dice.sound.disabled': 'Sound off',
    'dice.sound.muted': 'Sound muted',
    'dice.sound.roll': 'Roll sound',
    'dice.status.selectNumber': 'Select a number to roll',
    'dice.status.rolling': 'Rolling…',
    'dice.status.replay': 'Replay',
    'dice.status.ready': 'Ready',
    'dice.status.loading': 'Loading…',
    'dice.status.connecting': 'Connecting…',
    'dice.status.missingToken': 'Missing launch token',
    'dice.result.match.zero': 'No matches · x{multiplier}',
    'dice.result.match.one': '{count} match · x{multiplier}',
    'dice.result.match.two': '{count} matches · x{multiplier}',
    'dice.result.match.few': '{count} matches · x{multiplier}',
    'dice.result.match.many': '{count} matches · x{multiplier}',
    'dice.result.match.other': '{count} matches · x{multiplier}',
    'dice.history.title': 'History',
    'dice.history.empty': 'No rounds yet',
    'dice.history.round': 'Round',
    'dice.history.pick': 'Pick',
    'dice.history.dice': 'Dice',
    'dice.history.win': 'Win',
    'dice.history.when': 'Time',
    'dice.history.linkUnavailable': 'Link unavailable',
    'dice.rules.title': 'How to play Dice',
    'dice.rules.bullet1': 'Choose one number from 1 to 6.',
    'dice.rules.bullet2': 'Three dice are rolled.',
    'dice.rules.bullet3': 'One matching die pays x2.',
    'dice.rules.bullet4': 'Two matching dice pay x3.',
    'dice.rules.bullet5': 'Three matching dice pay x4.',
    'dice.rules.bullet6': 'Multipliers include the original stake.',
    'dice.rules.note': 'Outcomes are generated by the server.',
    'dice.rules.disclaimer': 'The showcase uses virtual demo credits.',
    'dice.rules.languageLink': 'Language',
    'dice.errors.launchFailed': 'Failed to start',
    'dice.errors.sessionExpired': 'Session expired',
    'dice.errors.replayNotFound': 'Replay not found',
    'dice.errors.replayPrivate': 'Replay is private',
    'dice.errors.replayUnavailable': 'Replay unavailable',
    'dice.errors.rateLimited': 'Too many requests',
    'dice.errors.generic': 'Something went wrong',
    'dice.errors.missingToken': 'No launch token provided',
    'dice.replay.title': 'Dice round',
    'dice.replay.badge': 'Replay',
    'dice.replay.pick': 'Pick',
    'dice.replay.dice': 'Dice',
    'dice.replay.bet': 'Bet',
    'dice.replay.win': 'Win',
    'dice.replay.multiplier': 'Multiplier',
    'dice.replay.when': 'When',
    'dice.replay.incomplete': 'Replay link incomplete',
    'dice.replay.loadFailed': 'Could not load replay',
    'dice.demo.note': 'DEMO — Virtual credits only.',
    'dice.a11y.selectNumber': 'Choose a number from 1 to 6',
    'dice.a11y.selectedNumber': 'Selected number',
    'dice.a11y.rollDice': 'Roll dice',
    'dice.a11y.history': 'Open round history',
    'dice.a11y.rules': 'Open game rules',
    'dice.a11y.sound': 'Toggle sound',
    'dice.a11y.balance': 'Balance',
    'dice.a11y.bet': 'Bet',
    'dice.a11y.lastWin': 'Last win',
    'dice.a11y.closeHistory': 'Close history',
    'dice.a11y.closeRules': 'Close rules',
    'dice.a11y.exitReplay': 'Exit replay',
    'dice.a11y.language': 'Choose language',
    'dice.loading.booting': 'Booting…',
    'lightning.game.title': 'Lightning Dice Roulette',
    'lightning.bonus.title': 'Lightning Bonus',
    'lightning.baseWin': 'Base Win',
    'lightning.lightning': 'Lightning',
    'lightning.totalWin': 'Total Win',
    'lightning.youWon': 'WIN',
    'lightning.reel.label': 'Lightning multiplier',
    'lightning.reel.spinning': 'Reel spinning…',
    'lightning.noMatch': 'No match',
    'lightning.notActivated': 'NO MATCH - LIGHTNING NOT ACTIVATED',
    'lightning.result.matchBase.zero': '0 matches · base {base}',
    'lightning.result.matchBase.one': '1 match · base {base}',
    'lightning.result.matchBase.other': '{count} matches · base {base}',
    'lightning.result.lossBase': '0 matches · base x0.0',
    'lightning.result.lightningBonus': 'Lightning {bonus}',
    'lightning.result.notActivated': 'Lightning not activated',
    'lightning.result.totalWin': 'Total {total} · Win {win}',
    'lightning.result.winOnly': 'Win {win}',
    'lightning.rules.title': 'How to play Lightning Dice Roulette',
    'lightning.rules.bullet1': 'Choose one number from 1 to 6.',
    'lightning.rules.bullet2': 'Three dice are rolled.',
    'lightning.rules.bullet3': 'One match pays 0.5x base.',
    'lightning.rules.bullet4': 'Two matches pay 1.0x base.',
    'lightning.rules.bullet5': 'Three matches pay 1.5x base.',
    'lightning.rules.bullet6': 'If at least one die matches, the Lightning multiplier reel spins and adds a bonus.',
    'lightning.rules.bullet7': 'If no dice match, the round loses and the reel does not spin.',
    'lightning.rules.note': 'Outcomes are generated by the server.',
    'lightning.rules.disclaimer': 'The showcase uses virtual demo credits.',
    'lnd.game.title': 'Lightning Dice',
    'lnd.panel.title': 'Lightning Numbers',
    'lnd.panel.label': 'Choose your number',
    'lnd.status.selectNumber': 'Select a number',
    'lnd.result.zeroMatches': '0 MATCHES',
    'lnd.result.matchesOne': '{count} MATCH',
    'lnd.result.matchesMany': '{count} MATCHES',
    'lnd.result.lightningApplied': 'LIGHTNING {mult}',
    'lnd.result.profitLine': 'PROFIT {mult} · {amount}',
    'lnd.result.stakeReturnLine': 'STAKE RETURN {mult} · {amount}',
    'lnd.result.totalPayoutLine': 'TOTAL PAYOUT {mult} · {amount}',
    'lnd.result.noLightning': 'No Lightning',
    'lnd.rules.title': 'How to play Lightning Dice',
    'lnd.rules.bullet1': 'Choose one number from 1 to 6.',
    'lnd.rules.bullet2': 'Up to three Lightning numbers are revealed before each roll.',
    'lnd.rules.bullet3': 'Three dice are rolled. Each matching die pays x0.5 profit.',
    'lnd.rules.bullet4': 'If at least one die matches, your stake is returned once.',
    'lnd.rules.bullet5': 'If your number is Lightning, its multiplier is added per matching die.',
    'lnd.rules.bullet6': 'If no dice match, the round loses and payout is zero.',
    'lnd.rules.note': 'Outcomes are generated by the server.',
    'lnd.rules.disclaimer': 'The showcase uses virtual demo credits.',
    'lnd.errors.insufficientBalance': 'Insufficient balance',
    'lnd.errors.roundFailed': 'Round failed. Please try again.',
    'lnd.orientation.title': 'Rotate your device',
    'lnd.orientation.message': 'Lightning Dice is available in portrait mode on mobile.',
};
export default messages;
//# sourceMappingURL=en.js.map